export default __webpack_public_path__ + "static/media/math.9bf17c328d7cd34226f83b354e16e4f4.svg";